class Math {
  // Use instead of % for negative numbers (https://stackoverflow.com/questions/4467539/javascript-modulo-gives-a-negative-result-for-negative-numbers)
  static mod = (n, m) => ((n % m) + m) % m;
}

export default Math;
